"use client";

import { Settings } from "react-slick";
import Image from "next/image";
import arrowLeft from "./arrow_left.png";
import arrowRight from "./arrow_right.png";
const styles = new Proxy({"SliderWrap":"SliderWrap-da226","Arrow":"Arrow-da226","ArrowPrev":"ArrowPrev-da226","ArrowNext":"ArrowNext-da226"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./CarouselSlider.scss";*/

// Shared react-slick building blocks for the theme's carousel-style widgets
// (Carousel, VideoCarousel). Use `styles.SliderWrap` around the <Slider> and
// pass className="CarouselSlider" to it for the shared dot styling.
export { styles as carouselStyles };

export const PrevArrow = ({ onClick }: { onClick?: () => void }) => (
  <button
    className={`${styles.Arrow} ${styles.ArrowPrev}`}
    onClick={onClick}
    aria-label="Previous"
  >
    <Image src={arrowLeft} alt="Previous" width={40} height={40} />
  </button>
);

export const NextArrow = ({ onClick }: { onClick?: () => void }) => (
  <button
    className={`${styles.Arrow} ${styles.ArrowNext}`}
    onClick={onClick}
    aria-label="Next"
  >
    <Image src={arrowRight} alt="Next" width={40} height={40} />
  </button>
);

export const CAROUSEL_SETTINGS: Settings = {
  dots: true,
  arrows: true,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  swipeToSlide: true,
  speed: 300,
  cssEase: "ease",
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        arrows: false,
      },
    },
  ],
};
